import InputDataPicker from './InputDataPicker';

export default InputDataPicker;
